'use strict';

require('core/main');
